import React from "react";

function Color_HWB() {
  return (
    <div>
      <h1>Color_HWB Component</h1>
      <p>This is the Color HWB tutorial page content.</p>
    </div>
  );
}

export default Color_HWB;
